import router from "../../router/index";
import t from "@common/src/i18n/t";
import { safeValue } from "@common/src/utils/common";
const user = {
  namespaced: true,
  state: {
    token: localStorage.getItem("se_authToken") || "",
    userData: JSON.parse(localStorage.getItem("se_userData")) || {},
    menuList: JSON.parse(localStorage.getItem("se_menus")) || [],
    permissionList: JSON.parse(localStorage.getItem("se_permission_list") || "[]"),
    selectedOrgCode: JSON.parse(localStorage.getItem("se_orgCode")) || "",
    defaultPlateProvince: localStorage.getItem("se_default_plate_province") || "",
    defaultPlateFirstLetter: localStorage.getItem("se_default_plate_first_letter") || "",
    storePayInfo: {},
    loginPageStatus: "login" // login selectStore forgetPwd succeeded
  },
  getters: {
    isLogin(state) {
      return state.token && Object.keys(state.userData).length > 0 && state.menuList.length > 0;
    },
    tenantCode(state) {
      try {
        return state.userData.storeList[0].tenantCode;
      } catch (e) {
        return "";
      }
    }
  },
  mutations: {
    setToken(state, data) {
      if (data || data === "") {
        state.token = data;
        localStorage.setItem("se_authToken", data);
      }
    },
    setHomeData(state, data) {
      state.homeData = data;
    },
    setUserData(state, data) {
      if (data) {
        state.userData = data;
        localStorage.setItem("se_userData", JSON.stringify(data));
      }
    },
    setOrgCode(state, data) {
      state.selectedOrgCode = data;
      localStorage.setItem("se_orgCode", JSON.stringify(data));
    },
    setMenuList(state, data) {
      if (data.length > 0) {
        state.menuList = data;
        localStorage.setItem("se_menus", JSON.stringify(data));
      }
    },
    setDefaultPlateProvince(state, data) {
      if (data) {
        state.defaultPlateProvince = data;
        localStorage.setItem("se_default_plate_province", data);
      } else {
        state.defaultPlateProvince = t("v210801.jing");
        localStorage.setItem("se_default_plate_province", t("v210801.jing"));
      }
    },
    setDefaultPlateFirstLetter(state, data) {
      if (data) {
        state.defaultPlateFirstLetter = data;
        localStorage.setItem("se_default_plate_first_letter", data);
      } else {
        state.defaultPlateFirstLetter = "";
        localStorage.setItem("se_default_plate_first_letter", "");
      }
    },
    setPermissionList(state, data) {
      if (data) {
        state.permissionList = data;
        localStorage.setItem("se_permission_list", JSON.stringify(data));
      }
    },
    setStorePayInfo(state, data) {
      state.storePayInfo = {
        appTypeDetailList: data?.data?.appTypeDetailList,
        hasUpgradeRenewalDiscount: data?.data?.hasUpgradeRenewalDiscount
      };
    },
    setLoginPageStatus(state, data) {
      state.loginPageStatus = data;
    }
  },
  actions: {
    async login({ rootState, commit }, params = {}) {
      const data = await rootState.http("/userAccount/login", params, {
        errorMessage: false
      });
      commit("setToken", data.data.userAuthToken);
      return data;
    },
    async changePassword({ rootState }, params = {}) {
      const data = await rootState.http("/userAccount/changePassword", params, {
        errorMessage: false
      });
      return data;
    },
    async getUserData({ rootState, commit }, params = {}) {
      const data = await rootState.http("/userAccount/getUserAccount", params);
      commit("setUserData", data.data);
    },
    async queryUserMenus({ rootState, commit }, params = {}) {
      const data = await rootState.http("/userAccount/queryUserMenus", params);
      commit("setMenuList", safeValue(data, "data.list", []));
      return data;
    },
    async loginOut({ rootState, commit }, params = {}) {
      const data = await rootState.http("/userAccount/logout", params);
      commit("setUserData", {});
      commit("setMenuList", []);
      commit("setToken", "");
      commit("app/setAppVersion", "", { root: true });
      router.push("/login");
      return data;
    },
    async getMobileCode({ rootState }, params = {}) {
      const data = await rootState.http("/basic/sendValidationCode", params, {
        errorMessage: false
      });
      return data;
    },
    async resetPassword({ rootState }, params = {}) {
      const data = await rootState.http("/userAccount/resetPassword", params, {
        errorMessage: false
      });
      return data;
    },
    async setCurrentStore({ rootState, commit, dispatch }, params = { orgCode: "" }) {
      const data = await rootState.http("/staff/setCurrentStore", params);
      commit("user/setOrgCode", params.orgCode, { root: true });
      commit("setDefaultPlateProvince", data.data.defaultPlateProvince);
      commit("setDefaultPlateFirstLetter", data.data.defaultPlateInitials);
      commit("app/setStoreLabelIconList", data.data.storeLabelIconList, { root: true });
      commit("app/setAppTypeLabelIcon", data.data.appTypeLabelIcon, { root: true });
      commit(
        "app/setAppVersionInfo",
        {
          tmall: data.data.tmallOpenFlag,
          appType: data.data.appType
        },
        { root: true }
      );
      commit("service/setTaxPayableDuringSettlement", data.data.taxPayableDuringSettlement, { root: true });
      dispatch("dashboard/getUnreadNoticeCount", "", { root: true });
      await dispatch("base/getSessionExtInfo", null, { root: true });
      await dispatch("store/getStoreInfo", { orgCode: params.orgCode }, { root: true });
      return data;
    },
    async queryUserResources({ rootState }, params = { orgCode: "" }) {
      const data = await rootState.http("/userAccount/queryUserResources", params);
      return data;
    },
    async queryStorePayInfo({ rootState, commit }, params = { orgCode: "" }) {
      const data = await rootState.http("/staff/setCurrentStore", params);
      commit("service/setTaxPayableDuringSettlement", data.data.taxPayableDuringSettlement, { root: true });
      commit("setStorePayInfo", data);
    }
  }
};

export default user;
